import React, { useEffect, useState } from "react";
import WINLogiMegenta from "./../../../src/assets/images/logo-win.svg";
import HighmarkLogoMegenta from "./../../../src/assets/images/highmark/ffb-logo.jpg";
import ReimbursementImage from "./../../../src/assets/images/WINCard-Fallback.jpg";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { Endpoints } from "../../Global/Endpoints";
import { useSelector } from "react-redux";


const WINPayLandingpage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [serviceDetails, setServiceDetails] = useState([]);
  const [error, setError] = useState(null);
  const token = localStorage.getItem('AccessToken');
  const contract = useSelector((state) => state.userData);
  const deviceType = "PatientPortal";
  const location = useLocation();
  const benefitsData = location.state?.Benifit;
  const WINCentive = location.state?.wincentiveparam || false;
      const [loading, setLoading] = useState(true);
  

  const handleBackClick = () => {
    if(benefitsData=="Benifit")
      {
        navigate("/benefits-landingpage");
      }
      else
      {
        navigate("/home");
      }
      
  };

  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";

  // Fetch service details on mount
  useEffect(() => {
    const fetchServiceDetails = async () => {
      try {
        const payload = {
          _Params: JSON.stringify({
            EmailId: contract.userData.EmailID,
            ServiceDescription: "WINPay",
            Contract: contract.userData.ContractIdentified,
            DeviceType: deviceType
          }),
        };
        const response = await axios.post(
          Endpoints.GetDashboardServiceDetails,
          payload,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data.ServiceDetails) {
          setServiceDetails(response.data.ServiceDetails);
        } else {
          toast.error(t("failedtoloadservices"));
        }
      } catch (error) {
        setError(t("errorloadingservices"));
      }finally {
      setLoading(false); // <-- Ensure loading is set to false after fetch
    }
    };

    fetchServiceDetails();
  }, [t]);

  // Check if only "Request a reimbursement" exists
  const isOnlyReimbursement =
    serviceDetails.length > 0 &&
    !serviceDetails.some(
      (service) =>
        service.ServiceDetailDescription === t('MyWINCards') ||
        service.ServiceDetailDescription === t('RequestanewWINCard')
    );

  // Navigation handler with data passing
  const handleNavigation = (path, data = null) => {
  const stateToPass = {
    WINCentive: WINCentive, // ✅ pass WINCentive in state
  };
  if (data) {
    stateToPass.serviceDetails = data;
  }
  navigate(path, { state: stateToPass });
};
 if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>        
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }

  return (
    <>
      <ToastContainer />

      {/* Page Header */}
      <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
        <button className="win-back-btn" onClick={handleBackClick}>
          <span>
            <i className="bi bi-chevron-left"></i>
            {!isHighmarkPortal && t("Back")}
          </span>
        </button>
        <h2 className="page-heading">
  {isHighmarkPortal ? "Pay" : t("winpay")}
</h2>
      </div>

      {/* WIN Card or Reimbursement Fallback */}
      <div className="col-sm-12 col-md-12 col-lg-6 mb-0 mb-md-5 mb-lg-0 support-services-image-wrapper">
        {isOnlyReimbursement ? (
          <div className="reimbursement-image-wrapper">
            <img
              src={ReimbursementImage}
              alt="Reimbursement"
              className="winpay-default-image"
            />
          </div>
        ) : (
          <div className="winpay-home-card-wrapper">
            <div className="win-logo-wrapper">
            {isHighmarkPortal ? 
                <img src={HighmarkLogoMegenta} alt="Highmark Logo" />
                :
                <img src={WINLogiMegenta} alt="WIN Logo" />
            }
              
            </div>
            <div className="win-card-number">1234 5678 1234 5678</div>
            <div className="win-card-expairy-details-wrapper">
              <div className="valid-thru-text">Valid Thru</div>
              <div className="valid-thru-details">01/25</div>
            </div>
          </div>
        )}
      </div>

      {/* Service Detail Blocks */}
      <div className="col-md-6 col-sm-12 mb-md-5 mb-ms-3 mb-5">
        {serviceDetails.map((service, index) => {
          const { ServiceDetailDescription } = service;
          let path = "";

          switch (ServiceDetailDescription) {
            case t('MyWINCards'):
              path = "/pay-tiles";
              break;
            case t('RequestanewWINCard'):
              path = "/pay-treatmentwithCard";
              break;
            case t('Uploadsupportingdocument'):
              path = "/pay-supportservicedocument";
              break;
            case t('Requestareimbursement'):
              path = "/pay-reimbursement";
              break;
            default:
              return null;
          }

          return (
            <div
              key={index}
              className="schedule-block mb-3"
              onClick={() =>
                path === "/pay-cards"
                  ? handleNavigation(path, serviceDetails)
                  : handleNavigation(path)
              }
              style={{ cursor: "pointer" }}
            >
              <span className="schedule-block-left-logo"></span>
              <div className="service-content find-provider align-self-center">
                <h4>{isHighmarkPortal && ServiceDetailDescription.includes("WINCard")
            ? ServiceDetailDescription.replace("WINCard", "Fertility and Family Building Card")
            : t(ServiceDetailDescription)}</h4>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default WINPayLandingpage;
